<template>
  <section>
    <Header :indexData="indexData" :userInfo="userInfo" :keyword="keyword"></Header>
    <div class="container">
      <div class="jesuanhd">订单支付</div>
      <div class="jiesuanbox">
        <div class="jstit">
          <span class="tit fl">支付方式</span>
        </div>
        <div class="selectgroup">
          <ul class="clearlist clearfix">
            <li :class="paymethod==2?'active':''" @click="paymethod=2">
              <img src="/static/images/icon_alipay.png" /> 支付宝支付
            </li>
            <li :class="paymethod==1?'active':''" @click="paymethod=1">
              <img src="/static/images/icon_wxpay.png" /> 微信支付
            </li>
            <li :class="paymethod==3?'active':''" @click="paymethod=3" v-if="routertype!='6-7'">
              <img src="/static/images/shouxin.png" /> 授信支付
            </li>
          </ul>
        </div>
      </div>
      <div class="jiesuanbox jieguo">
        <div class="icon">
          <i class="iconfont icon-gou2"></i>
        </div>
        <div class="jieguo-title">操作成功，请尽快完成支付</div>
        <div class="smzf">
          <div class="tit" v-if="paymethod==1">
            <i class="iconfont icon-wxpay" style="color: #19a041;"></i>
            <strong>
              微信支付：
              <span class="color-red">￥{{payInfo.amount}}</span>
            </strong>
          </div>
          <div class="tit zfb" v-if="paymethod==2">
            <i class="iconfont icon-alipay" style="color: #1296db;"></i>
            <strong>
              支付宝支付：
              <span class="color-red">{{payInfo.amount}}元</span>
            </strong>
          </div>
          <div class="tit zfb selectgroup" v-if="paymethod==3">
            <img src="/static/images/shouxin.png" style="width:18px;height:18px;" />
            <strong>
              授信支付：
              <span class="color-red">{{payInfo.amount}}元</span>
            </strong>
          </div>
          <div>
            <img :src="payImg" v-if="!isWeixinllq&&paymethod==1" />
            <el-button type="primary" v-if="paymethod==2">
              <a :href="base+'web/pay/alipay/orderno/'+orderno" class="pay">立即支付</a>
            </el-button>
            <el-button type="primary" @click="shouxinPay" v-if="paymethod==3">立即支付</el-button>
          </div>
          <div v-if="!isWeixinllq&&paymethod==1">扫描二维码支付</div>
        </div>
        <div class="text-center mt20">
          <el-button type="primary" @click="awaitPay">稍后支付</el-button>
        </div>
      </div>
    </div>
    <Footer :indexData="indexData"></Footer>
  </section>
</template>

<script>
import Header from "../components/header";
import Footer from "../components/footer";

layui.use(["layer"], function() {
  layer = layui.layer;
});
export default {
  components: {
    Header,
    Footer
  },
  name: "jieguo",
  data() {
    return {
      orderno: getParameterByName("orderno"),
      paymethod:getParameterByName("paymethod"),
      routertype:getParameterByName("routertype")||'1-1',
      base:sessionStorage.baseUrl,
      payImg: `${sessionStorage.baseUrl}web/pay/payqrcode?orderno=${getParameterByName(
        "orderno"
      )}`,
      payInfo: {},
      timeId: {},
      indexData: {},
      userInfo: {},
      keyword: "",
      autotroph: sessionStorage.autotroph,
      isWeixinllq: false
    };
  },
  methods: {
    // 点击稍后支付
    awaitPay() {
      clearInterval(this.timeId);
      location.hash=`#/usercenter?type=${this.routertype}`
      // self.location = "user_order.html";
    },
    
    onBridgeReady() {
      alert("进入支付的函数");
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: "wx2421b1c4370ec43b", //公众号名称，由商户传入
          timeStamp: "1395712654", //时间戳，自1970年以来的秒数
          nonceStr: "e61463f8efa94090b1f366cccfbbb444", //随机串
          package: "prepay_id=u802345jgfjsdfgsdg888",
          signType: "MD5", //微信签名方式：
          paySign: "70EA570631E4BB79628FBCA90534C63FF7FADD89" //微信签名
        },
        function(res) {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            // 使用以上方式判断前端返回,微信团队郑重提示：
            //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          }
        }
      );
    },
   async shouxinPay(){
      console.log("授信支付",this.orderno)
      let res= await this.$fetch("shop/payment", {
       body:{
            orderno: this.orderno,paymethod:3,
       }
      });
      if(res){
         this.$message.success('支付成功');
      }
      
    },
    gzhPay() {
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener(
            "WeixinJSBridgeReady",
            this.onBridgeReady,
            false
          );
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
          document.attachEvent("onWeixinJSBridgeReady", this.onBridgeReady);
        }
      } else {
        this.onBridgeReady();
      }
    },
    // 查询支付状态
   async getpaySatus(){
        this.payInfo = await this.$fetch("member/queryorder", {
       body:{
            guid: this.guid,
            orderno: getParameterByName("orderno")
       }
      });
      if (this.payInfo.paystatus == 1) {
        clearInterval(this.timeId);
        layer.alert("支付成功", { icon: 1 });
        self.location = "#/usercenter";
      }
    },
  },

  mounted:async function() {
      console.log("this.$router.params",getParameterByName('orderno'))
    var ua = window.navigator.userAgent.toLowerCase();
    ua.match(/MicroMessenger/i) == "micromessenger"?this.isWeixinllq = true:this.isWeixinllq = false;
     this.indexData = await this.$fetch("Index/indexdata");
    if (sessionStorage.user) {
      this.userInfo = JSON.parse(sessionStorage.user);
    }
    this.getpaySatus();
    this.timeId = setInterval(async () => {
    this.getpaySatus();
    }, 1000);
  },
    destroyed(){
          console.log('实例销毁完成');
            clearInterval(this.timeId);
            // layer.alert("实例销毁完成", { icon: 2 });
      }
};
</script>

  

 
<style lang='scss' scoped>
.zfb {
  margin-bottom: 20px;
}
.pay {
  // width: 200px;
  // background: #19a041;
  // color: #fff;
  font-size: 14px;
  // height: 50px;
  padding: 0;
  border: none;
  display: block;
  // margin: 20px auto;
  // line-height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/pages/jieguo.vue